module.exports = __webpack_public_path__ + "img/banner-1.1cf5b4b4.png";